import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 anim-fadeup">
      <div className="section-label">Get in Touch</div>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-slate-950 mt-3">Contact operations.</h1>
      <p className="mt-3 text-slate-600 max-w-2xl">
        For PPR, fuel inquiries, hangar leases, or general questions — give us a call or send an email.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-10">
        <div className="space-y-6">
          <Block icon={<Phone className="h-5 w-5" />} title="Phone" value="(606) 679-7908" sub="Sun-Sat 7am-6pm EST" />
          <Block icon={<Mail className="h-5 w-5" />} title="Email" value="fbo@flylcra.com" sub="Replied within 1 business day" />
          <Block icon={<MapPin className="h-5 w-5" />} title="Address" value="500 W.O. Newell Drive" sub="Somerset, KY 42503" />
          <Block icon={<Clock className="h-5 w-5" />} title="Hours" value="Sun-Sat 7am-6pm EST" sub="24/7 self-serve fuel" />
        </div>

        <form
          data-testid="contact-form"
          onSubmit={(e) => { e.preventDefault(); alert("Thanks! Operations will be in touch."); }}
          className="bg-slate-50 border border-slate-200 p-8 space-y-4"
        >
          <Field label="Your Name" name="name" required />
          <Field label="Email" name="email" type="email" required />
          <Field label="Aircraft Tail # (optional)" name="tail" />
          <div>
            <label className="text-sm font-medium text-slate-900 mb-1 block">Message</label>
            <textarea name="message" required rows={5} className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none" />
          </div>
          <button
            data-testid="contact-submit"
            type="submit"
            className="bg-slate-950 text-white px-6 py-3 font-semibold hover:bg-slate-800 transition-colors"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

function Block({ icon, title, value, sub }) {
  return (
    <div className="border-l-2 border-sky-500 pl-6">
      <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-sky-600">{icon}{title}</div>
      <div className="font-display text-2xl font-semibold text-slate-950 mt-1">{value}</div>
      <div className="text-sm text-slate-500">{sub}</div>
    </div>
  );
}

function Field({ label, name, type = "text", required }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-900 mb-1 block">{label}</label>
      <input
        data-testid={`contact-field-${name}`}
        name={name}
        type={type}
        required={required}
        className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none"
      />
    </div>
  );
}
